import { render } from "./TimetipSVG.vue?vue&type=template&id=1debdc33&scoped=true"
const script = {}

import "./TimetipSVG.vue?vue&type=style&index=0&id=1debdc33&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1debdc33"]])

export default __exports__